module.exports = __webpack_public_path__ + "img/027-kite.4045489d.svg";